import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { logout } from "./features/auth/authSlice";
import internetloss from "./assets/img/internet2.jpg";
import { fetchMenu, setMenuFetched } from "./features/global/globalSlice";
import { fetchCounties, fetchData } from "./features/fetch/fetchSlice";

export default function Root() {
  const urlFiltered = "auth/counties/getFiltered";
  const { isActive, user } = useSelector((state) => state.auth);
  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("selectedOrg")
  );
  const [selectedCounty, setSelectedCounty] = useState(
    localStorage.getItem("selectedCounty")
  );
  const [tokenExpired, setTokenExpired] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loc = useLocation();

  const token = localStorage.getItem("token"); 
  const isTokenExpired = (token) => {
    if (!token) return true;

    const decodedToken = token?.length && jwtDecode(token);
    const currentTime = Date.now() / 1000;

    return decodedToken.exp < currentTime;
  };

  useEffect(() => {
    if (!token) {
      setTokenExpired(true);
      dispatch(logout());
      // navigate("/login");
      return;
    }

    if (isTokenExpired(token)) {
      setTokenExpired(true);
      dispatch(logout());
      // navigate("/login");
      return;
    }
    setTokenExpired(false);
  }, [token, dispatch, navigate]);

  useEffect(() => {
    if (user) {
      dispatch(fetchMenu());
    }
  }, [user, selectedOrg, selectedCounty]);

  async function fetchCountyData() {
    await dispatch(fetchCounties());
  }
  async function fetchCountyFilteredData() {
    await dispatch(
      fetchData({
        url: urlFiltered,
        start: 0,
        limit: null,
      })
    );
  }

  useEffect(() => {
    if (user?.userInstitution === "CIDU") {
      // fetchCountyData();
      fetchCountyFilteredData();
    }
  }, [user]);

  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedOrg(localStorage.getItem("selectedOrg"));
      setSelectedCounty(localStorage.getItem("selectedCounty"));
    };

    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  if (!navigator.onLine) {
    return (
      <div className="w-full h-full overflow-y-scroll">
        <div className="flex flex-col items-center justify-center text-center py-0 lg:px-[50px] mx-[50px]">
          <h1 className="text-red font-[700]">Oops! Something went wrong...</h1>
          <p>You appear to be offline. Turn on your Wi-Fi to continue</p>
          <img src={internetloss} className="object-cover w-full h-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full h-full">
      {isActive &&
        !tokenExpired &&
        window.location.href != "/" &&
        loc?.pathname != "/" &&
        window.location.href != "/login-otp" &&
        loc?.pathname != "/login-otp" &&
        window.location.href != "/login-accounts" &&
        loc?.pathname != "/login-accounts" && <Header />}

      <div className="flex flex-col items-start w-full  h-full  ">
        <Outlet />
      </div>
    </div>
  );
}
